const DATE_PART = /^(\d{4})-(\d{2})-(\d{2})/
const TIME_PART = /T(\d{2}):(\d{2})/
const DAY_MS = 24 * 60 * 60 * 1000

export const formatDateOnly = (date) => {
  if (!date) return ''
  const d = date instanceof Date ? date : new Date(date)
  if (Number.isNaN(d.getTime())) return ''
  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, '0'),
    String(d.getDate()).padStart(2, '0'),
  ].join('-')
}

const localDisplayDate = (year, month, day, options) =>
  new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString('en-US', options)

export const flightDateKey = (value) => {
  if (!value) return ''
  const match = String(value).match(DATE_PART)
  return match ? `${match[1]}-${match[2]}-${match[3]}` : ''
}

export const formatFlightDate = (value, options = { weekday: 'short', month: 'short', day: 'numeric' }) => {
  if (!value) return ''
  const match = String(value).match(DATE_PART)
  if (match) return localDisplayDate(match[1], match[2], match[3], options)

  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString('en-US', options)
}

export const formatFlightTime = (value) => {
  if (!value) return ''
  const match = String(value).match(TIME_PART)
  if (match) {
    const hours = Number(match[1])
    const suffix = hours >= 12 ? 'PM' : 'AM'
    const hour12 = hours % 12 || 12
    return `${hour12}:${match[2]} ${suffix}`
  }

  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
}

const ymdToUtcDay = (key) => {
  const match = key.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!match) return null
  return Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])) / DAY_MS
}

export const calendarDayDiff = (start, end) => {
  const startDay = ymdToUtcDay(flightDateKey(start))
  const endDay = ymdToUtcDay(flightDateKey(end))
  if (startDay == null || endDay == null) return 0
  return endDay - startDay
}
